import { render, staticRenderFns } from "./user-communication.vue?vue&type=template&id=0998544f&scoped=true"
import script from "./user-communication.vue?vue&type=script&lang=js"
export * from "./user-communication.vue?vue&type=script&lang=js"
import style0 from "./user-communication.vue?vue&type=style&index=0&id=0998544f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998544f",
  null
  
)

export default component.exports